export const FormatsData: import('../../../sim/dex-species').ModdedSpeciesFormatsDataTable = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "OU",
		doublesTier: "DOU",
	},
	venusaurmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "RU",
		doublesTier: "DOU",
	},
	charizardmegax: {
		tier: "OU",
		doublesTier: "DOU",
	},
	charizardmegay: {
		tier: "RUBL",
		doublesTier: "DOU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "RU",
		doublesTier: "DOU",
	},
	blastoisemega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "RU",
		doublesTier: "DOU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "RU",
		doublesTier: "DOU",
	},
	beedrillmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pidgeotmega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	rattata: {
		tier: "LC",
	},
	rattataalola: {
		tier: "LC",
	},
	raticate: {
		tier: "RU",
		doublesTier: "DOU",
	},
	raticatealola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachu: {
		tier: "LC",
	},
	pikachustarter: {
		isNonstandard: null,
		tier: "RU",
		doublesTier: "DOU",
	},
	raichu: {
		tier: "RU",
		doublesTier: "DOU",
	},
	raichualola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandshrewalola: {
		tier: "LC",
	},
	sandslash: {
		tier: "UU",
		doublesTier: "DOU",
	},
	sandslashalola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		tier: "OU",
		doublesTier: "DOU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		tier: "UU",
		doublesTier: "DOU",
	},
	clefairy: {
		tier: "LC",
	},
	clefable: {
		tier: "OU",
		doublesTier: "DOU",
	},
	vulpix: {
		tier: "LC",
	},
	vulpixalola: {
		tier: "LC",
	},
	ninetales: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ninetalesalola: {
		tier: "UU",
		doublesTier: "DOU",
	},
	jigglypuff: {
		tier: "LC",
	},
	wigglytuff: {
		tier: "RU",
		doublesTier: "DOU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "RU",
		doublesTier: "DOU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		tier: "RU",
		doublesTier: "DOU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		tier: "RU",
		doublesTier: "DOU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	diglett: {
		tier: "LC",
	},
	diglettalola: {
		tier: "LC",
	},
	dugtrio: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dugtrioalola: {
		tier: "OU",
		doublesTier: "DOU",
	},
	meowth: {
		tier: "LC",
	},
	meowthalola: {
		tier: "LC",
	},
	persian: {
		tier: "RU",
		doublesTier: "DOU",
	},
	persianalola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "UU",
		doublesTier: "DOU",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		tier: "RU",
		doublesTier: "DOU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		tier: "UU",
		doublesTier: "DOU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "NFE",
	},
	alakazam: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	alakazammega: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NFE",
	},
	machamp: {
		tier: "RU",
		doublesTier: "DOU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		tier: "UU",
		doublesTier: "DOU",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		tier: "RU",
		doublesTier: "DOU",
	},
	geodude: {
		tier: "LC",
	},
	geodudealola: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	graveleralola: {
		tier: "NFE",
	},
	golem: {
		tier: "UU",
		doublesTier: "DOU",
	},
	golemalola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		tier: "RU",
		doublesTier: "DOU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		tier: "UU",
		doublesTier: "DOU",
	},
	slowbromega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "RU",
		doublesTier: "DOU",
	},
	farfetchd: {
		tier: "RU",
		doublesTier: "DOU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		tier: "UU",
		doublesTier: "DOU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "RU",
		doublesTier: "DOU",
	},
	grimer: {
		tier: "LC",
	},
	grimeralola: {
		tier: "LC",
	},
	muk: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mukalola: {
		tier: "OU",
		doublesTier: "DOU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "NFE",
	},
	gengar: {
		tier: "OU",
		doublesTier: "DOU",
	},
	gengarmega: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	onix: {
		tier: "RU",
		doublesTier: "DOU",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		tier: "RU",
		doublesTier: "DOU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "UU",
		doublesTier: "DOU",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		tier: "UU",
		doublesTier: "DOU",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		tier: "UU",
		doublesTier: "DOU",
	},
	exeggutoralola: {
		tier: "OU",
		doublesTier: "DOU",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		tier: "RU",
		doublesTier: "DOU",
	},
	marowakalola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	hitmonlee: {
		tier: "RU",
		doublesTier: "DOU",
	},
	hitmonchan: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lickitung: {
		tier: "RU",
		doublesTier: "DOU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		tier: "RU",
		doublesTier: "DOU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "OU",
		doublesTier: "DOU",
	},
	chansey: {
		tier: "RU",
		doublesTier: "DOU",
	},
	tangela: {
		tier: "RU",
		doublesTier: "DOU",
	},
	kangaskhan: {
		tier: "RU",
		doublesTier: "DOU",
	},
	kangaskhanmega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "RU",
		doublesTier: "DOU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "RU",
		doublesTier: "DOU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		tier: "OU",
		doublesTier: "DOU",
	},
	mrmime: {
		tier: "RU",
		doublesTier: "DOU",
	},
	scyther: {
		tier: "RU",
		doublesTier: "DOU",
	},
	jynx: {
		tier: "RU",
		doublesTier: "DOU",
	},
	electabuzz: {
		tier: "RU",
		doublesTier: "DOU",
	},
	magmar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pinsir: {
		tier: "UU",
		doublesTier: "DOU",
	},
	pinsirmega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	tauros: {
		tier: "UU",
		doublesTier: "DOU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gyaradosmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	lapras: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ditto: {
		tier: "RU",
		doublesTier: "DOU",
	},
	eevee: {
		tier: "LC",
	},
	eeveestarter: {
		isNonstandard: null,
		tier: "RU",
		doublesTier: "DOU",
	},
	vaporeon: {
		tier: "OU",
		doublesTier: "DOU",
	},
	jolteon: {
		tier: "OU",
		doublesTier: "DOU",
	},
	flareon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	porygon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "RU",
		doublesTier: "DOU",
	},
	aerodactyl: {
		tier: "OU",
		doublesTier: "DOU",
	},
	aerodactylmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	snorlax: {
		tier: "UU",
		doublesTier: "DOU",
	},
	articuno: {
		tier: "RU",
		doublesTier: "DOU",
	},
	zapdos: {
		tier: "OU",
		doublesTier: "DOU",
	},
	moltres: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		tier: "UU",
		doublesTier: "DOU",
	},
	mewtwo: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	mewtwomegax: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	mewtwomegay: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	mew: {
		tier: "OU",
		doublesTier: "DOU",
	},
	meltan: {
		isNonstandard: null,
		tier: "RU",
		doublesTier: "DOU",
	},
	melmetal: {
		isNonstandard: null,
		tier: "OU",
		doublesTier: "DOU",
	},
};
